import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CaseListPage } from "./CaseListPage";
import { NewCasePage } from "./NewCasePage";
import { CaseDetailPage } from "./CaseDetailPage";
import { NotificationSettingsPage } from "./NotificationSettingsPage";

export function DdsRoutes() {
  return (
    <Routes>
      <Route index element={<CaseListPage />} />
      <Route path="new" element={<NewCasePage />} />
      <Route path="settings" element={<NotificationSettingsPage />} />
      <Route path="cases/:caseId" element={<CaseDetailPage />} />
      <Route path="*" element={<Navigate to="/dds" replace />} />
    </Routes>
  );
}
